module.exports = __webpack_public_path__ + "static/media/ic_rec_start.0f79071b.svg";